import {
  pushEnrichedEventToDataLayerWithCleanUp,
  pushEventToDataLayer
} from "seneca-common/features/analytics";
import { withLogAndSwallowError } from "seneca-common/utils/senecaAnalytics";

export const analyticsLogNewServiceWorkerInstalled = withLogAndSwallowError(
  newServiceWorkerInstalled
);

export const analyticsLogNewVersionAvailableToastShown = withLogAndSwallowError(
  newVersionAvailableToastShown
);

export const analyticsLogForcesUpdateWithoutUserInput = withLogAndSwallowError(
  forcesUpdateWithoutUserInput
);

export const analyticsLogToastClosed = withLogAndSwallowError(toastClosed);

export const analyticsLogUserClickedCTAOnToast = withLogAndSwallowError(
  userClickedCTAOnToast
);

export const analyticsLogUserClickedCancelOnToast = withLogAndSwallowError(
  userClickedCancelOnToast
);

const nameSpace = "s/pwa";

function newServiceWorkerInstalled() {
  pushEventToDataLayer({
    event: `${nameSpace}/new-service-worker-installed`
  });
}

function newVersionAvailableToastShown(
  toastType: string = "new-version-available"
) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: `${nameSpace}/new-version-available-toast-shown`,
    payload: {
      toastType
    }
  });
}

function forcesUpdateWithoutUserInput() {
  pushEventToDataLayer({
    event: `${nameSpace}/forced-update-without-user-input`
  });
}

function toastClosed(toastType: string) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: `${nameSpace}/update-toast-closed`,
    payload: {
      toastType
    }
  });
}

function userClickedCTAOnToast(toastType: string) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: `${nameSpace}/clicked-cta-on-update-toast`,
    payload: {
      toastType
    }
  });
}

function userClickedCancelOnToast(toastType: string) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: `${nameSpace}/clicked-cancel-on-update-toast`,
    payload: {
      toastType
    }
  });
}
